import React from "react";
import { AlertCircle } from "lucide-react";
import { consultationTypes } from "./constants";

export default function StepTypeSelector({ onSelect }) {
  return (
    <div className="space-y-6" data-testid="step-1-type">
      <h2 className="font-serif text-2xl text-center text-emerald_deep mb-8">Choose Consultation Type</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {consultationTypes.map((type) => (
          <button key={type.id} onClick={() => onSelect(type)} data-testid={`consultation-type-${type.id}`}
            className={`relative text-left p-8 border bg-surface hover:border-accent/50 hover:bg-bone transition-all duration-300 rounded-xl ${
              type.popular ? "border-accent ring-1 ring-accent/30" : "border-border_custom"
            }`}>
            {type.popular && (
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent text-white text-[10px] font-semibold tracking-widest uppercase px-4 py-1 rounded-full" data-testid="most-popular-badge">
                Most Popular
              </div>
            )}
            <div className="flex items-start justify-between mb-4">
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${
                type.popular ? "border-2 border-accent bg-accent/5" : "border border-border_custom"
              }`}>
                <type.icon className={`w-5 h-5 ${type.popular ? "text-accent" : "text-emerald_deep"}`} />
              </div>
              <div className="text-right">
                <div className="text-2xl font-serif text-emerald_deep">{"\u20B9"}{type.price.toLocaleString()}</div>
                <div className="text-xs text-text_muted">{type.duration}</div>
              </div>
            </div>
            <h3 className="font-serif text-lg text-emerald_deep mb-1">{type.title}</h3>
            <p className="text-sm text-accent mb-3">{type.subtitle}</p>
            <p className="text-sm text-text_muted leading-relaxed mb-4">{type.description}</p>
            <div className="space-y-1">
              {type.notes.map((note) => (
                <div key={note} className="flex items-center gap-2 text-xs text-accent/80">
                  <AlertCircle size={12} className="flex-shrink-0" /><span>{note}</span>
                </div>
              ))}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
